<div class="image-view-editor">
  <sc-flex >
    <label for="picture-btn">
      <sc-dictionary-label dictionaryKey="tmc-yard.widgets.image-view-admin.upload.label"></sc-dictionary-label>
    </label>
    <input
      #pictureBtn
      id="picture-btn"
      name="picture-btn"
      class="picture-input-field"
      type="file"
      accept="image/*"
      (change)="handlePictureEvent($event)"/>
    <sc-flex-fitting-content>
    <span>{{filename}}</span>
  </sc-flex-fitting-content>
    <button mat-flat-button (click)="chooseAndUpload()">
      <sc-dictionary-label dictionaryKey="tmc-yard.widgets.image-view-admin.upload.button"></sc-dictionary-label>
    </button>
  </sc-flex>
  <!-- Loading spinner to prevent user from doing anything during validation. -->
  <div class="loading-spinner" *ngIf="requestRunning">
    <i class="spinner fa-light fa-spinner fa-spin"></i>
  </div>
</div>
